import React from 'react';
import { PartnerWidget } from '../components/PartnerWidget';

// Embed page - standalone version of the widget for iframe embedding
// Activates postMessage-based auto-resize for parent iframe communication
const EmbedPage = () => {
  return (
    <div className="embed-container" style={{ background: 'transparent' }}>
      <PartnerWidget isEmbed={true} />
    </div>
  );
};

export default EmbedPage;
